// extracted by mini-css-extract-plugin
export default {"ModalText":"Modal_ModalText__K7j-6","show":"Modal_show__RHtpb"};